import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "results-information",
  "data-test": "results-information"
}
const _hoisted_2 = {
  class: "page-title",
  "aria-level": "2",
  "data-test": "title"
}
const _hoisted_3 = {
  key: 1,
  class: "results-understanding",
  "data-test": "results-understanding"
}
const _hoisted_4 = {
  class: "accoridon-title",
  "data-test": "results-label"
}
const _hoisted_5 = {
  slot: "content",
  "data-test": "results-content"
}

import { computed } from "vue";
import { IonAccordion, IonAccordionGroup, IonItem } from "@ionic/vue";
import { SanityBlocks } from "sanity-blocks-vue-component";
import { useAssessmentStore } from "@/store";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssessmentScores',
  setup(__props) {

const assessmentStore = useAssessmentStore();

const assessment = computed(() => {
  return assessmentStore.getAssessmentDetail;
});

const assessmentResults = computed(() => {
  return assessmentStore.getAssessmentResults;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (assessment.value.resultsInformation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(SanityBlocks), {
            blocks: assessment.value.resultsInformation
          }, null, 8, ["blocks"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(assessment.value.resultsTitle), 1),
    (assessment.value.resultsUnderstanding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(SanityBlocks), {
            blocks: assessment.value.resultsUnderstanding
          }, null, 8, ["blocks"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonAccordionGroup), {
      multiple: true,
      class: "results-accordion-group",
      "data-test": "results-accordion-group"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessmentResults.value.criteria, (result) => {
          return (_openBlock(), _createBlock(_unref(IonAccordion), {
            key: result.criterion_id,
            "data-test": "results-accordion"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), { slot: "header" }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", _hoisted_4, _toDisplayString(result.title) + ": " + _toDisplayString(result.score), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(SanityBlocks), {
                  blocks: result.description
                }, null, 8, ["blocks"])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})